import { pickLiveHeroEvent } from './personHeroCover.js';

const RESERVED = new Set(['video', 'videos', 'categories', 'category', 'browse']);

export function kickSlugFromUrl(url) {
  const raw = String(url || '').trim();
  if (!raw) return null;
  try {
    const parsed = new URL(raw.includes('://') ? raw : `https://${raw}`);
    const host = parsed.hostname.replace(/^www\./, '').toLowerCase();
    if (host !== 'kick.com' && host !== 'kick.tv') return null;
    const first = parsed.pathname.replace(/^\/+|\/+$/g, '').split('/')[0];
    if (!first || RESERVED.has(first.toLowerCase())) return null;
    return first.toLowerCase();
  } catch {
    return null;
  }
}

export function kickSlugFromHub(hub, results = []) {
  const pids = hub?.entity?.platformIds;
  const fromIds = String(pids?.kick || '').trim().replace(/^@/, '').toLowerCase();
  if (fromIds) return fromIds;

  const chips = [
    ...(Array.isArray(hub?.streamingPlatforms) ? hub.streamingPlatforms : []),
    ...(Array.isArray(hub?.links) ? hub.links : []),
  ];
  for (const chip of chips) {
    const key = String(chip?.key || chip?.kind || '').toLowerCase();
    if (key && key !== 'kick') continue;
    const slug = kickSlugFromUrl(chip?.url);
    if (slug) return slug;
  }

  const live = pickLiveHeroEvent(results, hub);
  if (String(live?.platform || '').toLowerCase() === 'kick') {
    const login = String(live.channelLogin || '').trim().replace(/^@/, '').toLowerCase();
    if (login) return login;
    return kickSlugFromUrl(live.url);
  }

  return null;
}

/**
 * True when the person hub should show Kick Follow.
 * Official slug, streaming chips, Kick links, or a live Kick search row.
 */
export function personHubHasKickIdentity(hub, results = []) {
  if (kickSlugFromHub(hub, results)) return true;

  const pids = hub?.entity?.platformIds;
  if (String(pids?.kick || '').trim()) return true;

  const chips = [
    ...(Array.isArray(hub?.streamingPlatforms) ? hub.streamingPlatforms : []),
    ...(Array.isArray(hub?.links) ? hub.links : []),
  ];
  for (const chip of chips) {
    const key = String(chip?.key || chip?.kind || '').toLowerCase();
    if (key === 'kick') return true;
    if (kickSlugFromUrl(chip?.url)) return true;
  }

  return false;
}

export async function fetchKickChannelBio(slug, fetcher = fetch) {
  const login = String(slug || '').trim().replace(/^@/, '').toLowerCase();
  if (!login) return null;
  try {
    const response = await fetcher(`https://kick.com/api/v2/channels/${encodeURIComponent(login)}`, {
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) return null;
    const payload = await response.json();
    const bio = payload?.user?.bio || payload?.bio || payload?.description || null;
    const text = String(bio || '').trim();
    return text || null;
  } catch {
    return null;
  }
}
